import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { UserService } from './user.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [UserService],
})
export class UserModule {}
